import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Grid,
  Typography,
  Divider,
  IconButton,
  ListItem,
  ListItemIcon,
  DialogContent,
  Dialog,
  DialogContentText,
  DialogActions,
  DialogTitle,
  Tooltip,
} from "@material-ui/core";
import { AssignmentTurnedIn, Edit, Delete, Close } from "@material-ui/icons";
import { Mention, MentionsInput } from "react-mentions";
import ModalCard from "./ModalCard";
import Avatars from "./ModalContent/Avatars";
import Descripcion from "./ModalContent/Descripcion";
import Actividades from "./ModalContent/Actividades";
import SubjectIcon from "@material-ui/icons/Subject";
import Lista from "./ModalContent/Lista";
import ModalAdjuntosComentario from "./ModalContent/Actions/ModalAdjuntosComentario";
import CheckListProgressBar from "./ModalContent/CheckListProgressBar";
import serviciosTablero from "utils/serviciosTablero";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
import DescriptionIcon from "@material-ui/icons/Description";
import CloseIcon from "@material-ui/icons/Close";
import AttachFile from "@material-ui/icons/AttachFile";
import iconExcel from "../../../assets/excel.png";
import iconPDF from "../../../assets/pdf.png";
import iconWord from "../../../assets/word.png";
import iconImage from "../../../assets/imagen.png";
import { makeStyles } from "@material-ui/core/styles";
import CheckboxFecha from "./ModalContent/Actions/CheckboxFecha";
import { Page } from "components";

const stylesMention = {
  userMention: {
    backgroundColor: "#999999",
    borderRadius: "9px",
    color: "#000000",
  },
  mention: {
    control: {
      backgroundColor: "#2C2C2C",
      fontFamily: "Arial",
      color: "#CCCCCC",
    },
    "&multiLine": {
      control: {
        fontFamily: "Arial",
        minHeight: 63,
        color: "#CCCCCC",
      },
      highlighter: {
        padding: 9,
        border: "1px solid transparent",
      },
      input: {
        padding: 9,
        border: "1px solid silver",
        color: "#CCCCCC",
      },
    },
    "&singleLine": {
      display: "inline-block",
      width: 180,
      highlighter: {
        padding: 1,
        border: "2px inset transparent",
      },
      input: {
        padding: 1,
        border: "2px inset",
        color: "#CCCCCC",
      },
    },
    suggestions: {
      list: {
        backgroundColor: "#282E33",
        border: "1px solid rgba(0,0,0,0.15)",
        borderRadius: "3px",
        color: "#89939E",
        fontSize: 16,
      },
      item: {
        padding: "5px 15px",
        borderBottom: "1px solid rgba(0,0,0,0.15)",
        "&focused": {
          backgroundColor: "#323940",
        },
      },
    },
  },
};

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
  },
  card: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1),
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    padding: theme.spacing(1),
    transition: "transform 0.2s ease-in-out",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  cardContent: {
    padding: theme.spacing(1),
    textAlign: "center",
  },
  title: {
    fontWeight: "bold",
    fontSize: "1rem",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));
const Tarjeta = ({
  open,
  onClose,
  titulo,
  tarjeta,
  setParticipantesTarjeta,
  setEtiquetasTarjeta,
  setListasTarjeta,
  setCargando,
  setMensaje,
  infoTablero,
  cargarTablero,
  updateData,
  idjerarquia,
  usuario,
  permisos,
  dataEtapa,
  setFechasTarjeta,
}) => {
  const titleStyle = {
    display: "flex",
    alignItems: "center",
  };
  const classesTablero = useStylesTablero();
  const [openDialog, setOpenDialog] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [activities, setActivities] = useState([]); // Inicializar como arreglo vacío
  const creatorName = "Jonathan Andrade";
  const [checklists, setChecklists] = useState([]);
  const [adjunto, setAdjunto] = useState([]);
  const [miembros, setMiembros] = useState([]);
  const [editingChecklistId, setEditingChecklistId] = useState(null);
  const [tempTitle, setTempTitle] = useState("");
  const [fechaInicio, setFechaInicio] = useState([]);
  const [fechaFin, setFechaFin] = useState([]);
  const [cargandoListas, setCargandoListas] = useState(false);
  const [cargandoComentarios, setCargandoComentarios] = useState(false);
  const [adjuntoComentario, setAdjuntoComentario] = useState({
    open: false,
    files: [],
  });
  const classes = useStyles();

  // Estados para los las menciones de comentarios
  const [labelText, setLabelText] = useState("");
  const [usuariosMention, setUsuariosMention] = useState([]);

  const cerrarMensaje = () => setMensaje({ open: false });

  const getComentarios = () => {
    serviciosTablero.verComentarios(
      (estado, mensaje, data) => {
        if (estado === 1 && data) {
          setActivities(Array.isArray(data) ? data : []);
        } else {
          console.error("Error al cargar actividades:", mensaje);
          setActivities([]);
        }
      },
      setCargando,
      { idtarjeta: tarjeta?.idtarjeta }
    );
  };
  const getMiembrosTablero = () => {
    serviciosTablero.getParticipantesTablero(
      (data) => {
        setUsuariosMention(
          data?.participantes?.map((miembro) => {
            return { id: miembro.idusuario, display: miembro.nombre };
          }) || []
        );
      },
      setCargando,
      { idtablero: infoTablero?.idtablero, soloParticipantes: true }
    );
  };
  const saveActivity = () => {
    if (!labelText.trim()) return;

    let formData = new FormData();
    adjuntoComentario?.files?.map((value, index) => {
      formData.append("archivo_" + index, value.data);
    });

    formData.append("texto", labelText);
    formData.append("idtarjeta", tarjeta?.idtarjeta);
    formData.append("narchivos", adjuntoComentario?.files?.length || 0);

    serviciosTablero.agregarComentarios(
      (estado, mensaje, data) => {
        setMensaje({ open: true, status: estado, value: mensaje });
        if (estado === 1 && data) {
          setActivities(data);
          setLabelText("");
        } else {
          console.error("Error al guardar la actividad:", mensaje);
        }

        setAdjuntoComentario({ open: false, files: [] });
      },
      setCargando,
      formData
    );
  };

  const editActivity = (index, newText, adjuntosEdit, adjuntosOriginales) => {
    let files = [];
    let filesEliminar = [];
    let formData = new FormData();

    if (adjuntosEdit?.length >= 0 && adjuntosOriginales) {
      // Buscamos archivos a eliminar
      adjuntosOriginales?.map((file) => {
        let existeUpdate = adjuntosEdit?.find(
          (fileUpdate) => fileUpdate?.idarchivo == file.idarchivo
        );
        if (!existeUpdate) filesEliminar.push(file.idarchivo);
      });

      // Buscamos los nuevos archivos a subir
      adjuntosEdit.map((file) => {
        if (!file?.idarchivo) files.push(file);
      });
    }

    if (files?.length > 0) {
      files?.map((value, index) => {
        formData.append("archivo_" + index, value.data);
      });
    }

    formData.append("narchivos", files?.length || 0);
    formData.append("idcomentario", activities[index].idcomentario);
    formData.append("texto", newText);
    formData.append("idtarjeta", tarjeta?.idtarjeta);
    formData.append("eliminar", filesEliminar);

    serviciosTablero.editarComentarios(
      (estado, mensaje, data) => {
        if (estado === 1) {
          setActivities(data);
          setMensaje({ open: true, status: estado, value: mensaje });
        } else {
          setMensaje({
            open: true,
            status: -1,
            value: "Error al editar la actividad:",
          });
        }
      },
      setCargando,
      formData
    );
  };

  const getMiembrosTarjeta = () => {
    serviciosTablero.getTarjetaMiembros(
      (status, mensaje, data) => {
        if (status === 1 && data) {
          setMiembros(data);
        } else {
          console.error("Error al obtener los miembros:", mensaje);
        }
      },
      setCargando,
      { idtarjeta: tarjeta?.idtarjeta }
    );
  };
  //ETIQUETAS
  const getEtiquetasTarjeta = () => {
    serviciosTablero.getEtiquetaTarjeta(
      (status, mensaje, data) => {
        if (status === 1) {
          setLabels(data);
          setEtiquetasTarjeta(data);
          //SET DE FECHAS
          setFechaFin(data.ffin);
          setFechaInicio(data.finicio);
        } else {
          console.error("Error al obtener las etiquetas:", mensaje);
        }
      },
      setCargando,
      { idtarjeta: tarjeta?.idtarjeta }
    );
  };
  //CHECKLISTS
  const handleCreateChecklist = (data) => {
    setChecklists((prev) => {
      let newCheckList = [...prev, data.checklist];
      return newCheckList;
    });
  };
  const getChecklists = () => {
    serviciosTablero.getChecklist(
      (status, mensaje, data) => {
        if (status === 1) {
          setChecklists(data);
        } else {
          console.error("Error al cargar checklists:", mensaje);
        }
      },
      setCargandoListas,
      { idtarjeta: tarjeta }
    );
  };
  const handleEditChecklist = (idlista, nuevoTitulo) => {
    serviciosTablero.editChecklist(
      (status, mensaje, data) => {
        if (status === 1) {
          setChecklists((prevChecklists) =>
            prevChecklists.map((checklist) =>
              checklist.idlista === idlista
                ? { ...checklist, titulo: nuevoTitulo }
                : checklist
            )
          );
          setEditingChecklistId(null);
          setMensaje({ open: true, status: status, value: mensaje });
        } else {
          console.error("Error al cargar checklists:", mensaje);
          setMensaje({ open: true, status: status, value: mensaje });
        }
      },
      setCargando,
      { idlista: idlista, titulo: nuevoTitulo }
    );
  };
  const handleDeleteChecklist = (idlista) => {
    serviciosTablero.deleteChecklist(
      (status, mensaje, data) => {
        if (status === 1) {
          setChecklists((prevChecklists) =>
            prevChecklists.filter((checklist) => checklist.idlista !== idlista)
          );

          setMensaje({ open: true, status: status, value: mensaje });

          setListasTarjeta(data.progreso);
          let nuevaDataTarjeta = { ...tarjeta, progreso: data.progreso };
          updateData("tarjeta", nuevaDataTarjeta, tarjeta.idtarjeta);
        } else {
          console.error("Error al cargar checklists:", mensaje);
          setMensaje({ open: true, status: status, value: mensaje });
        }
      },
      setCargando,
      { idlista: idlista }
    );
  };
  //Etiquetas
  const [labels, setLabels] = useState([]);

  const handleEtiquetaChange = (updatedLabels) => {
    setLabels((prev) => {
      let newLabels = [...prev, updatedLabels];

      setEtiquetasTarjeta(newLabels);
      let nuevaDataTarjeta = { ...tarjeta, etiquetas: newLabels };
      updateData("tarjeta", nuevaDataTarjeta, tarjeta.idtarjeta);
      return newLabels;
    }); // Actualizar el estado global con el nuevo archivo
  };
  const onSolicitudChange = (data) => {
    let nuevaDataTarjeta = { ...tarjeta, idsolicitud: data.idsolicitud };
    updateData("tarjeta", nuevaDataTarjeta, tarjeta.idtarjeta);
  };
  //OBTENER FECHA
  //Seleccion de checkbox
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(tarjeta?.ffin);
  const [tarjetaInfo, setTarjetaInfo] = useState(null);

  const getFechas = () => {
    serviciosTablero.getTarjetaData(
      (estatus, mensaje, data) => {
        // setMensaje({ open: true, status: estatus, value: mensaje });
        if (estatus > 0) {
          if (data.general.finicio && data.general.ffin) {
            let fechaInicio = new Date(data.general.finicio);
            let fechaFinal = new Date(data.general.ffin);
            setStartDate(fechaInicio);
            setEndDate(fechaFinal);
            setTarjetaInfo(data.general);
          }
        }
      },
      setCargando,
      { idtarjeta: tarjeta }
    );
  };
  const onFechaChange = (data, solicitud) => {
    if (solicitud) {
      setTarjetaInfo({
        ...tarjetaInfo,
        idsolicitud_fecha: data?.idsolicitud_fecha,
      });
      return;
    }
    let finicioNew = new Date(data.finicio);
    let ffinNew = new Date(data.ffin);
    setStartDate(finicioNew);
    setEndDate(ffinNew);
    setFechasTarjeta({ fechaInicio: finicioNew, fechaFinal: ffinNew });

    let nuevaDataTarjeta = { ...tarjeta, finicio: finicioNew, ffin: ffinNew };
    updateData("tarjeta", nuevaDataTarjeta, tarjeta.idtarjeta);
    setTarjetaInfo(nuevaDataTarjeta);
  };
  //--------------
  const handleDeleteEtiqueta = (etiquetaEliminada) => {
    setLabels((prev) => {
      let newLabels = prev.filter(
        (etiqueta) => etiqueta.idetiqueta !== etiquetaEliminada.idetiqueta
      );

      setEtiquetasTarjeta(newLabels);
      let nuevaDataTarjeta = { ...tarjeta, etiquetas: newLabels };
      updateData("tarjeta", nuevaDataTarjeta, tarjeta.idtarjeta);
      return newLabels;
    });
  };
  const handleEditEtiqueta = (etiquetaEditada) => {
    setLabels((prev) => {
      let newLabels = prev.map((label) => {
        let newLabel =
          label.idetiqueta === etiquetaEditada.idetiqueta
            ? { ...label, ...etiquetaEditada }
            : label;
        return newLabel;
      });

      setEtiquetasTarjeta(newLabels);
      let nuevaDataTarjeta = { ...tarjeta, etiquetas: newLabels };
      updateData("tarjeta", nuevaDataTarjeta, tarjeta.idtarjeta);

      return newLabels;
    });
  };
  //ADJUNTOS
  const getFileIcon = (mimeType) => {
    switch (mimeType) {
      case "application/pdf":
        return (
          <img
            src={iconPDF}
            alt="PDF Icon"
            style={{ width: "50px", height: "50px" }}
          />
        );
      case "image/jpeg":
      case "image/png":
      case "image/gif":
        return (
          <img
            src={iconImage}
            alt="Image Icon"
            style={{ width: "50px", height: "50px" }}
          />
        );
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      case "application/vnd.ms-excel":
        return (
          <img
            src={iconExcel}
            alt="Excel Icon"
            style={{ width: "50px", height: "50px" }}
          />
        );
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        return (
          <img
            src={iconWord}
            alt="Word Icon"
            style={{ width: "50px", height: "50px" }}
          />
        );
      default:
        return <DescriptionIcon />;
    }
  };
  const handleFileAdded = (newFile) => {
    setAdjunto((prev) => [...prev, newFile]); // Actualizar el estado global con el nuevo archivo
  };
  const getAdjuntos = () => {
    serviciosTablero.getDocumentationTarjeta(
      (status, mensaje, data) => {
        if (status === 1) {
          setAdjunto(data);
        } else {
          console.error("Error al cargar adjuntos:", mensaje);
        }
      },
      setCargando,
      { idtarjeta: tarjeta }
    );
  };
  const deleteFile = (archivo) => {
    serviciosTablero.updateFileTarjeta(
      (estatus, mensaje, response) => {
        if (estatus == 1) {
          setAdjunto((prev) =>
            prev.filter((adjunto) => adjunto.idarchivo !== archivo.idarchivo)
          );
          setMensaje({ open: true, status: estatus, value: mensaje });
        } else {
          setMensaje({ open: true, status: estatus, value: mensaje });
        }
      },
      setCargando,
      { idtarjeta: tarjeta.idtarjeta, idarchivo: archivo.idarchivo }
    );
  };

  const handleIconClick = (archivo) => {
    if (archivo?.url || archivo?.ruta) {
      // Determinar la URL
      const fileUrl = archivo.url || archivo.ruta;

      // Crear un enlace temporal
      const link = document.createElement("a");
      link.href = fileUrl;
      link.target = "_blank"; // Abrir en una nueva pestaña
      document.body.appendChild(link);

      // Simular un clic
      link.click();

      // Eliminar el enlace temporal
      document.body.removeChild(link);
    } else {
      console.error("No se encontró la URL del archivo.");
    }
  };
  //DIALOGOS DE CONFIRMACION

  //Dialog para Lista de tareas
  const handleClickOpen = (index) => {
    setSelectedIndex(index);
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };
  const handleConfirmDeleteListaTareas = () => {
    if (selectedIndex !== null) {
      handleDeleteChecklist(selectedIndex);
      handleClose();
    }
  };

  //
  useEffect(() => {
    if (open) {
      getMiembrosTarjeta();
      getComentarios();
      getChecklists();
      getEtiquetasTarjeta();
      getAdjuntos();
      getMiembrosTablero();
      getFechas();
    }
  }, [open]);

  return (
    <ModalCard
      open={open}
      onClose={onClose}
      titulo={titulo}
      tarjeta={tarjeta}
      miembros={miembros}
      setMiembros={setMiembros}
      dataEtapa={dataEtapa}
      tarjetainfo={tarjetaInfo}
      permisos={permisos}
      setCargando={setCargando}
      
    >
      <Grid container spacing={2}>
        <Grid item sm={9} xs={12}>
          <Grid container>
            <Grid item xs={12} sm={4}>
              <Avatars
                tarjeta={tarjeta?.idtarjeta}
                dataTarjeta={tarjeta}
                miembros={miembros}
                setCargando={setCargando}
                setMiembros={setMiembros}
                setParticipantesTarjeta={setParticipantesTarjeta}
                setMensaje={setMensaje}
                infoTablero={infoTablero}
                updateData={updateData}
              />
            </Grid>
            {labels.length > 0 && (
              <Grid item xs={12} sm={6}>
                <Typography
                  variant="h6"
                  marginBottom={2}
                  style={{ color: "#CCCCCC" }}
                >
                  Etiquetas
                </Typography>
                <Grid
                  container
                  display="flex"
                  flexDirection="row"
                  alignItems="flex-start"
                >
                  {labels.map((etiqueta) => (
                    <Grid
                      item
                      key={etiqueta.idetiqueta}
                      style={{
                        backgroundColor: etiqueta.color,
                        color: "#fff",
                        fontFamily: "arial",
                        borderRadius: "4px",
                        marginBottom: "8px",
                        textAlign: "center",
                        minWidth: "120px", // Ajustar el ancho mínimo
                        fontSize: "0.875rem", // Tamaño de texto para etiquetas
                        marginRight: "5px",
                      }}
                    >
                      {etiqueta.nombre}
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            )}
          </Grid>
          <Grid>
            {endDate && tarjetaInfo ? (
              <Box display="flex" alignItems="center">
                <CheckboxFecha
                  fechaInicio={startDate}
                  fechaFin={endDate}
                  tipo={1}
                  tarjetaInfo={tarjetaInfo}
                  setTarjetaInfo={setTarjetaInfo}
                  setCargando={setCargando}
                  setMensaje={setMensaje}
                  tarjeta={tarjeta}
                  solicitudActiva={tarjetaInfo?.idsolicitud_fecha}
                  updateData={updateData}
                />
              </Box>
            ) : (
              ""
            )}
            {tarjetaInfo?.idsolicitud_fecha &&
              "Solicitud de cambio de fecha activa"}
          </Grid>
          <Grid container>
            <Grid
              container
              spacing={2}
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "flex-start", // Alinear de izquierda a derecha
                gap: "12px", // Espaciado reducido entre cards
                padding: "12px", // Menor padding alrededor del contenedor
              }}
            >
              {adjunto?.length > 0
                ? adjunto.map((item, itemIndex) => (
                    <Grid
                      item
                      key={itemIndex}
                      style={{
                        flex: "0 1 calc(20% - 12px)", // Cards más pequeñas (20% del ancho)
                        maxWidth: "calc(20% - 12px)", // Consistencia en el ancho
                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)", // Sombra más notable
                        backgroundColor: "#323940", // Fondo más oscuro
                        borderRadius: "6px", // Bordes redondeados más sutiles
                        padding: "12px", // Menor espaciado interno
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Tooltip title={item?.narchivo || "sin nombre"}>
                        <ListItem
                          id={`btnArchivo${item?.idarchivo}`}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "relative",
                            width: "100%",
                            height: "80px", // Altura más pequeña
                            borderRadius: "6px",
                            backgroundColor: "#424A54", // Fondo más claro para contraste
                          }}
                        >
                          {/* Ícono de archivo */}

                          <IconButton
                            id={`btnDescargarArchivo${item?.idarchivo}`}
                            onClick={() => handleIconClick(item)}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <ListItemIcon
                              style={{
                                fontSize: "16px", // Ícono más pequeño
                                justifyContent: "center",
                                color: "#FFF", // Íconos en blanco para resaltar en el fondo oscuro
                              }}
                            >
                              {getFileIcon(item.mimeType)}
                            </ListItemIcon>
                          </IconButton>

                          {/* Botón de eliminar */}
                          <IconButton
                            title={"ELIMINAR ARCHIVO"}
                            id={`btnEliminarArchivo${item?.idarchivo}`}
                            onClick={() => deleteFile(item)}
                            style={{
                              position: "absolute",
                              top: "4px",
                              right: "4px",
                              padding: "4px",
                              color: "#FF6B6B", // Rojo claro para el botón de eliminar
                            }}
                            disabled={
                              !(
                                idjerarquia == 2 ||
                                [2, 3].includes(usuario[0]?.idrol)
                              )
                            }
                          >
                            <CloseIcon style={{ fontSize: "12px" }} />{" "}
                            {/* Ícono más pequeño */}
                          </IconButton>
                        </ListItem>
                      </Tooltip>
                    </Grid>
                  ))
                : ""}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Descripcion
              tarjeta={tarjeta?.idtarjeta}
              setCargando={setCargando}
              setMensaje={setMensaje}
            />
            {checklists?.length > 0 && (
              <Divider style={{ backgroundColor: "gray" }} />
            )}
            {/* CARGANDO PARA EL CHECKLIST */}

            <Box style={{ marginTop: "10px" }}>
              {checklists.map((checklist, index) => (
                <div
                  key={index}
                  style={{ backgroundColor: "#2C3238", borderRadius: "5px" }}
                >
                  <Grid
                    container
                    spacing={0}
                    alignItems="center"
                    style={{ marginBottom: "8px" }}
                  >
                    {/* Ícono de la checklist */}
                    <Grid item xs={1}>
                      <AssignmentTurnedIn />
                    </Grid>

                    {/* Título de la checklist */}
                    <Grid item xs={9}>
                      {editingChecklistId === checklist.idlista ? (
                        <TextField
                          fullWidth
                          value={tempTitle}
                          onChange={(e) => setTempTitle(e.target.value)}
                          variant="outlined"
                          className={classesTablero.field}
                        />
                      ) : (
                        <Typography style={{ whiteSpace: "pre-line" }}>
                          {checklist.titulo}
                        </Typography>
                      )}
                    </Grid>

                    {/* Botones de acción */}
                    <Grid item xs={2}>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="flex-end"
                        gap={1}
                      >
                        {editingChecklistId === checklist.idlista ? (
                          <>
                            <IconButton
                              color="secondary"
                              onClick={() =>
                                handleEditChecklist(
                                  checklist.idlista,
                                  tempTitle
                                )
                              }
                            >
                              <AssignmentTurnedIn />
                            </IconButton>
                            <IconButton
                              color="secondary"
                              onClick={() => setEditingChecklistId(null)}
                            >
                              <Close />
                            </IconButton>
                          </>
                        ) : (
                          <>
                            <IconButton
                              color="secondary"
                              onClick={() => {
                                setEditingChecklistId(checklist.idlista);
                                setTempTitle(checklist.titulo);
                              }}
                              title="Editar"
                              disabled={
                                !(
                                  idjerarquia == 2 ||
                                  [2, 3].includes(usuario[0]?.idrol)
                                )
                              }
                            >
                              <Edit />
                            </IconButton>
                            <IconButton
                              style={{ color: "#e57373" }}
                              onClick={() => handleClickOpen(checklist.idlista)}
                              title="Eliminar"
                              disabled={
                                !(
                                  idjerarquia == 2 ||
                                  [2, 3].includes(usuario[0]?.idrol)
                                )
                              }
                            >
                              <Delete />
                            </IconButton>
                          </>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                  {cargandoListas ? (
                    <Page cargando={cargandoListas}>
                      <Box style={{ marginTop: "10px" }}> </Box>
                    </Page>
                  ) : (
                    <CheckListProgressBar
                      tasks={checklist.tasks}
                      lista={checklist.idlista}
                      setCargando={setCargando}
                      setMensaje={setMensaje}
                      setListasTarjeta={setListasTarjeta}
                      tarjeta={tarjeta}
                      updateData={updateData}
                      idjerarquia={idjerarquia}
                      usuario={usuario}
                      permisos={permisos}
                    />
                  )}
                </div>
              ))}
            </Box>
            <Divider style={{ backgroundColor: "gray" }} />
            <Box sx={titleStyle}>
              <SubjectIcon
                sx={{ marginRight: 1 }}
                style={{ color: "#CCCCCC" }}
              />
              <Typography
                variant="h6"
                component="h2"
                style={{ color: "#CCCCCC" }}
              >
                Comentarios
              </Typography>
            </Box>
            <MentionsInput
              style={stylesMention.mention}
              value={labelText}
              onChange={(e) => setLabelText(e.target.value)}
            >
              <Mention
                data={usuariosMention}
                style={stylesMention.userMention}
                displayTransform={(id, username) => `@${username}`}
              />
            </MentionsInput>
            <Grid container>
              <Grid item xs={7}>
                <Button
                  variant="contained"
                  color="#146C94"
                  onClick={saveActivity}
                  style={{
                    marginBottom: "16px",
                    backgroundColor: "#FFFFFF",
                    marginTop: "5px",
                  }}
                  size="small"
                >
                  Guardar Comentario
                </Button>
                <Button
                  variant="contained"
                  color="#146C94"
                  onClick={() =>
                    setAdjuntoComentario({ ...adjuntoComentario, open: true })
                  }
                  style={{
                    marginBottom: "16px",
                    marginLeft: "5px",
                    backgroundColor: "gray",
                    marginTop: "5px",
                  }}
                  size="small"
                  title="Adjuntar archivos"
                >
                  <AttachFile />
                </Button>
              </Grid>
              <Grid
                item
                xs={5}
                style={{
                  marginBottom: "8px",
                  marginTop: "8px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "start",
                  alignItems: "flex-start",
                }}
              >
                {adjuntoComentario?.files?.length > 0 && (
                  <Typography>
                    {"(" + adjuntoComentario.files.length + ") adjuntos"}
                  </Typography>
                )}
              </Grid>
            </Grid>
            <ModalAdjuntosComentario
              adjuntoComentario={adjuntoComentario}
              setAdjuntoComentario={setAdjuntoComentario}
              tarjeta={tarjeta}
              setCargando={setCargando}
              setMensaje={setMensaje}
              onClose={() => setAdjuntoComentario({ open: false, files: [] })}
            />
            {cargandoComentarios ? (
              <Page cargando={cargandoComentarios}>
                <Box style={{ marginTop: "10px" }}> </Box>
              </Page>
            ) : (
              <Actividades
                activities={activities}
                setActivities={setActivities}
                editActivity={editActivity}
                creatorName={creatorName}
                tarjeta={tarjeta?.idtarjeta}
                setCargando={setCargando}
                setMensaje={setMensaje}
                stylesMention={stylesMention}
                usuariosMention={usuariosMention}
                getFileIcon={getFileIcon}
                idjerarquia={idjerarquia}
                usuario={usuario}
                permisos={permisos}
              />
            )}
          </Grid>

          {/* Dialogo al eliminar una lista de treas */}
          <Dialog
            open={openDialog}
            onClose={handleClose}
            fullWidth={true}
            maxWidth={"sm"}
          >
            <DialogTitle className={classesTablero.dialogTitle}>
              ¡ADVERTENCIA!{" "}
              <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={handleClose}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <DialogContentText style={{ color: "white" }}>
                La lista de tareas se eliminará permanentemente, ¿desea
                continuar?
              </DialogContentText>
            </DialogContent>
            <DialogActions style={{ justifyContent: "flex-end" }}>
              <Button onClick={handleClose} color="secondary">
                Cancelar
              </Button>
              <Button
                onClick={handleConfirmDeleteListaTareas}
                className={classesTablero.btnEliminar}
              >
                Eliminar
              </Button>
            </DialogActions>
          </Dialog>
        </Grid>
        <Grid item sm={3} xs={12}>
          <Lista
            onCreateChecklist={handleCreateChecklist}
            miembros={miembros}
            tarjeta={tarjeta?.idtarjeta}
            dataTarjeta={tarjeta}
            setMiembros={setMiembros}
            setParticipantesTarjeta={setParticipantesTarjeta}
            setCargando={setCargando}
            setMensaje={setMensaje}
            infoTablero={infoTablero}
            onDeleteEtiqueta={handleDeleteEtiqueta}
            onEtiquetaEdit={handleEditEtiqueta}
            onEtiquetaChange={handleEtiquetaChange}
            labels={labels}
            adjunto={adjunto}
            onFileAdded={handleFileAdded}
            onCloseModalCard={onClose}
            cargarTablero={cargarTablero}
            updateData={updateData}
            idjerarquia={idjerarquia}
            usuario={usuario}
            permisos={permisos}
            onSolicitudChange={onSolicitudChange}
            onFechaChange={onFechaChange}
            tarjetaInfo={tarjetaInfo}
          />
        </Grid>
      </Grid>
    </ModalCard>
  );
};

export default Tarjeta;
